import React from 'react';

const SaleSoonPage = () => {
  return (
    <section className='page-container'>
      <div className='order-page sale-soon-stage'>
        <div className='center-items-horizontal'>
            <div className='page-header'>
                <h2>LVLCS x WORLD MOBILE TOKEN FOOTBALL JERSEY IRL</h2>
                <p className='minting-coming-text'>The private sale has already ended!<br/>Come here for the public sale from <span>10:00 AM CST on December 20th</span> through <span>December 22nd at 2:00 PM CST</span></p>
            </div>
        </div>
      </div>
    </section>
  );
};

export default SaleSoonPage;